// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f93c6e9","239":"cdf6197a","453":"72ba67fb","667":"f726d25d"}[chunkId] + ".chunk.js";
};